"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.parserState = exports.$R$0 = exports.$TV = exports.$TS = exports.$TR = exports.$T = exports.$Y = exports.$N = exports.$TEXT = exports.$P = exports.$Q = exports.$E = exports.$S = exports.$C = exports.$R = exports.$L = exports.$EXPECT = void 0;
function $EXPECT(parser, fail, expectation) {
    return function (state) {
        var result = parser(state);
        if (result)
            return result;
        var pos = state.pos;
        fail(pos, expectation);
        return;
    };
}
exports.$EXPECT = $EXPECT;
/**
 * Match a string literal.
 */
function $L(str) {
    return function (state) {
        var input = state.input, pos = state.pos;
        var length = str.length;
        if (input.substr(pos, length) === str) {
            return {
                loc: {
                    pos: pos,
                    length: length
                },
                pos: pos + length,
                value: str
            };
        }
        return;
    };
}
exports.$L = $L;
/**
 * Match a regular expression (must be sticky).
 */
function $R(regExp) {
    return function (state) {
        var input = state.input, pos = state.pos;
        regExp.lastIndex = state.pos;
        var l, m, v;
        if (m = input.match(regExp)) {
            v = m[0];
            l = v.length;
            return {
                loc: {
                    pos: pos,
                    length: l
                },
                pos: pos + l,
                value: m
            };
        }
        return;
    };
}
exports.$R = $R;
function $C() {
    var terms = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        terms[_i] = arguments[_i];
    }
    return function (state) {
        var i = 0;
        var l = terms.length;
        while (i < l) {
            var r = terms[i++](state);
            if (r)
                return r;
        }
        return;
    };
}
exports.$C = $C;
function $S() {
    var terms = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        terms[_i] = arguments[_i];
    }
    return function (state) {
        var input = state.input, pos = state.pos, i = 0, value;
        var results = [], s = pos, l = terms.length;
        while (i < l) {
            var r = terms[i++]({ input: input, pos: pos });
            if (r) {
                (pos = r.pos, value = r.value);
                results.push(value);
            }
            else
                return;
        }
        return {
            loc: {
                pos: s,
                length: pos - s
            },
            pos: pos,
            value: results
        };
    };
}
exports.$S = $S;
// a? zero or one
function $E(fn) {
    return function (state) {
        var r = fn(state);
        if (r)
            return r;
        var pos = state.pos;
        return {
            loc: {
                pos: pos,
                length: 0
            },
            pos: pos,
            value: undefined
        };
    };
}
exports.$E = $E;
// *
// NOTE: zero length repetitions (where position doesn't advance) return
// an empty array of values. A repetition where the position doesn't advance
// would be an infinite loop, so this avoids that problem cleanly.
// Since this always returns a result `&x*` will always succeed and `!x*` will
// always fail. Same goes for `&x?` and `!x?`. Relatedly `&x+ == &x` and
// `!x+ == !x`.
function $Q(fn) {
    return function (state) {
        var input = state.input, pos = state.pos;
        var value;
        var s = pos;
        var results = [];
        while (true) {
            var prevPos = pos;
            var r = fn({ input: input, pos: pos });
            if (r == undefined)
                break;
            (pos = r.pos, value = r.value);
            if (pos === prevPos)
                break;
            else
                results.push(value);
        }
        return {
            loc: {
                pos: s,
                length: pos - s
            },
            pos: pos,
            value: results
        };
    };
}
exports.$Q = $Q;
// + one or more
function $P(fn) {
    return function (state) {
        var input = state.input, s = state.pos;
        var value;
        var first = fn(state);
        if (!first)
            return;
        var pos = first.pos;
        var results = [first.value];
        while (true) {
            var prevPos = pos;
            var r = fn({ input: input, pos: pos });
            if (!r)
                break;
            (pos = r.pos, value = r.value);
            if (pos === prevPos)
                break;
            results.push(value);
        }
        return {
            loc: {
                pos: s,
                length: pos - s
            },
            value: results,
            pos: pos
        };
    };
}
exports.$P = $P;
// $ prefix operator, convert result value to a string spanning the
// matched input
function $TEXT(fn) {
    return function (state) {
        var newState = fn(state);
        if (!newState)
            return;
        newState.value = state.input.substring(state.pos, newState.pos);
        return newState;
    };
}
exports.$TEXT = $TEXT;
// ! prefix operator
function $N(fn) {
    return function (state) {
        var newState = fn(state);
        if (newState)
            return;
        return {
            loc: {
                pos: state.pos,
                length: 0
            },
            value: undefined,
            pos: state.pos
        };
    };
}
exports.$N = $N;
// & prefix operator
function $Y(fn) {
    return function (state) {
        var newState = fn(state);
        if (!newState)
            return;
        return {
            loc: {
                pos: state.pos,
                length: 0
            },
            value: undefined,
            pos: state.pos
        };
    };
}
exports.$Y = $Y;
// Transform
// simplest value mapping transform, doesn't include location data parameter
function $T(parser, fn) {
    return function (state) {
        var result = parser(state);
        if (!result)
            return;
        var value = result.value;
        var mappedValue = fn(value);
        //@ts-ignore
        result.value = mappedValue;
        return result;
    };
}
exports.$T = $T;
// Transform RegExp
// Result handler for regexp match expressions
// $0 is the whole match, followed by $1, $2, etc.
function $TR(parser, fn) {
    return function (state) {
        var result = parser(state);
        if (!result)
            return;
        var loc = result.loc, value = result.value;
        var mappedValue = fn.apply(void 0, __spreadArray([loc], value, false));
        //@ts-ignore
        result.value = mappedValue;
        return result;
    };
}
exports.$TR = $TR;
// Transform sequence
function $TS(parser, fn) {
    return function (state) {
        var result = parser(state);
        if (!result)
            return;
        var loc = result.loc, value = result.value;
        var mappedValue = fn.apply(void 0, __spreadArray([loc, value], value, false));
        //@ts-ignore
        result.value = mappedValue;
        return result;
    };
}
exports.$TS = $TS;
// Transform value $0 and $1 are both singular value
function $TV(parser, fn) {
    return function (state) {
        var result = parser(state);
        if (!result)
            return;
        var loc = result.loc, value = result.value;
        var mappedValue = fn(loc, value, value);
        //@ts-ignore
        result.value = mappedValue;
        return result;
    };
}
exports.$TV = $TV;
// Default regexp result handler RegExpMatchArray => $0
function $R$0(parser) {
    return function (state) {
        var result = parser(state);
        if (!result)
            return;
        var value = result.value[0];
        //@ts-ignore
        result.value = value;
        return result;
    };
}
exports.$R$0 = $R$0;
// End of machinery
// Parser specific things below
var failHintRegex = /\S+|\s+|$/y;
// Error tracking
// Goal is zero allocations
var failExpected = Array(16);
var failIndex = 0;
var maxFailPos = 0;
function fail(pos, expected) {
    if (pos < maxFailPos)
        return;
    if (pos > maxFailPos) {
        maxFailPos = pos;
        failExpected.length = failIndex = 0;
    }
    failExpected[failIndex++] = expected;
    return;
}
function parserState(grammar) {
    /** Utility function to convert position in a string input to line:colum */
    function location(input, pos) {
        var _a = input.split(/\n|\r\n|\r/).reduce(function (_a, line) {
            var row = _a[0], col = _a[1];
            var l = line.length + 1;
            if (pos > l) {
                pos -= l;
                return [row + 1, 1];
            }
            else if (pos >= 0) {
                col += pos;
                pos = -1;
                return [row, col];
            }
            else {
                return [row, col];
            }
        }, [1, 1]), line = _a[0], column = _a[1];
        return "".concat(line, ":").concat(column);
    }
    function validate(input, result, _a) {
        var filename = _a.filename;
        if (result && result.pos === input.length)
            return result.value;
        var expectations = Array.from(new Set(failExpected.slice(0, failIndex)));
        var l = location(input, maxFailPos);
        // The parse completed with a result but there is still input
        if (result && result.pos > maxFailPos) {
            l = location(input, result.pos);
            throw new Error("\n".concat(filename, ":").concat(l, " Unconsumed input at #{l}\n\n").concat(input.slice(result.pos), "\n    "));
        }
        if (expectations.length) {
            failHintRegex.lastIndex = maxFailPos;
            var hint = input.match(failHintRegex)[0];
            if (hint.length)
                hint = JSON.stringify(hint);
            else
                hint = "EOF";
            throw new Error("\n".concat(filename, ":").concat(l, " Failed to parse\nExpected:\n\t").concat(expectations.join("\n\t"), "\nFound: ").concat(hint, "\n"));
        }
        if (result) {
            throw new Error("\nUnconsumed input at ".concat(l, "\n\n").concat(input.slice(result.pos), "\n"));
        }
        throw new Error("No result");
    }
    return {
        parse: function (input, options) {
            if (options === void 0) { options = {}; }
            if (typeof input !== "string")
                throw new Error("Input must be a string");
            var parser = (options.startRule != null)
                ? grammar[options.startRule]
                : Object.values(grammar)[0];
            if (!parser)
                throw new Error("Could not find rule with name '#{opts.startRule}'");
            var filename = options.filename || "<anonymous>";
            failIndex = 0;
            maxFailPos = 0;
            failExpected.length = 0;
            return validate(input, parser({ input: input, pos: 0 }), {
                filename: filename
            });
        }
    };
}
exports.parserState = parserState;


const { parse } = parserState({
  Template: Template,
Line: Line,
LineBody: LineBody,
RestOfLine: RestOfLine,
DeprecatedEquals: DeprecatedEquals,
Tag: Tag,
OptionalClasses: OptionalClasses,
Classes: Classes,
Class: Class,
OptionalIds: OptionalIds,
Ids: Ids,
Id: Id,
IdError: IdError,
ClassError: ClassError,
TagName: TagName,
OptionalAttributes: OptionalAttributes,
Attribute: Attribute,
AtIdentifier: AtIdentifier,
EqBinding: EqBinding,
Identifier: Identifier,
Indent: Indent,
_: _,
__: __,
Value: Value,
DoubleStringCharacter: DoubleStringCharacter,
SingleStringCharacter: SingleStringCharacter,
EscapeSequence: EscapeSequence,
Number: Number,
EOS: EOS,
EOL: EOL,
EOF: EOF
})

const $L0 = $L("|");
const $L1 = $L(" ");
const $L2 = $L("=");
const $L3 = $L("");
const $L4 = $L(".");
const $L5 = $L("#");
const $L6 = $L("(");
const $L7 = $L(")");
const $L8 = $L("@");
const $L9 = $L("  ");
const $L10 = $L("\t");
const $L11 = $L("\"");
const $L12 = $L("'");
const $L13 = $L("\\");
const $L14 = $L("\r\n");
const $L15 = $L("\n");
const $L16 = $L("\r");

const $R0 = $R(new RegExp("[^\\n\\r]*", 'suy'));
const $R1 = $R(new RegExp("[a-zA-Z][a-zA-Z0-9-]*", 'suy'));
const $R2 = $R(new RegExp("[ \\t]+", 'suy'));
const $R3 = $R(new RegExp("[ \\t]", 'suy'));
const $R4 = $R(new RegExp(".", 'suy'));
const $R5 = $R(new RegExp("-?[0-9]+\\.[0-9]+", 'suy'));
const $R6 = $R(new RegExp("-?[0-9]+", 'suy'));
const $R7 = $R(new RegExp("[\\s\\S]", 'suy'));

const Template$0 = $TS($S($E(__), $Q(Line)), function($loc, $0, $1, $2) {var top = a => a[a.length-1];
function reduceLines(lines) {
  var depth = 0;
  var stack = [[]];
  var firstIndent = 0;
  lines.forEach( ([indent, line]) => {
    if (firstIndent === 0 && indent > depth + 1) {
      firstIndent = indent - 1;
    }
    indent = indent > firstIndent ? indent - firstIndent : indent;
    if (Array.isArray(line)) {
      line[1] = collectAttributes(line[1])
    }
    if (depth+1 === indent) {
      // We're adding to the content of the last element in the current stack
      stack.push(top(top(stack))[2])
    } else if ( indent > depth) {
      throw new Error("Indented too far")
    } else if (indent < depth) {
      stack = stack.slice(0, indent + 1)
    }
    depth = indent
    top(stack).push(line)
  })
  return stack[0]
}
function collectAttributes(attributesArray) {
  return attributesArray.reduce((o, [key, value]) => {
    if (key === "id" || key === "class" || key === "style") {
      var p = o[key] || (o[key] = [])
      p.push(value)
    } else {
      o[key] = value
    }
    return o
  }, {})
}
function pretty(lines) {
  return lines.map(line =>
    JSON.stringify(line)
  )
}
var reduced = reduceLines($2);
if (reduced.length != 1) {
  throw new Error("Must have exactly one root node.");
}
return reduced[0];});
function Template(state) {
  return Template$0(state);
}

const Line$0 = $T($S(Indent, LineBody, EOS), function(value) { return [value[0], value[1]] });
function Line(state) {
  return Line$0(state);
}

const LineBody$0 = $TS($S(Tag, $E(DeprecatedEquals), _, RestOfLine), function($loc, $0, $1, $2, $3, $4) {$1[2].push($4)
return $1});
const LineBody$1 = $T($S(Tag, $E(_)), function(value) { return value[0] });
const LineBody$2 = $TS($S($EXPECT($L0, fail, "LineBody \"|\""), $E($EXPECT($L1, fail, "LineBody \" \"")), RestOfLine), function($loc, $0, $1, $2, $3) {return $3 + "\n";});
const LineBody$3 = $T($S($E($S(DeprecatedEquals, _)), RestOfLine), function(value) { return value[1] });
function LineBody(state) {
  return LineBody$0(state) || LineBody$1(state) || LineBody$2(state) || LineBody$3(state)
}

const RestOfLine$0 = $TR($EXPECT($R0, fail, "RestOfLine /[^\\n\\r]*/"), function($loc, $0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {// TODO: Handle runs of text with bound content inside
if ($0.slice(0,1) === "@") {
  return {
    bind: $0.slice(1)
  }
} else {
  return $0
}});
function RestOfLine(state) {
  return RestOfLine$0(state);
}

const DeprecatedEquals$0 = $TV($EXPECT($L2, fail, "DeprecatedEquals \"=\""), function($loc, $0, $1) {console.warn("'= <content>' is deprecated, you can remove the '=' without issue.")});
function DeprecatedEquals(state) {
  return DeprecatedEquals$0(state);
}

const Tag$0 = $TS($S(TagName, OptionalIds, OptionalClasses, OptionalAttributes), function($loc, $0, $1, $2, $3, $4) {return [
  $1,
  $2.concat($3, $4),
  [],
]});
const Tag$1 = $TS($S(Ids, OptionalClasses, OptionalAttributes), function($loc, $0, $1, $2, $3) {return [
  "div",
  $1.concat($2, $3),
  [],
]});
const Tag$2 = $TS($S(Classes, OptionalAttributes), function($loc, $0, $1, $2) {return [
  "div",
  $1.concat($2),
  [],
]});
function Tag(state) {
  return Tag$0(state) || Tag$1(state) || Tag$2(state)
}

const OptionalClasses$0 = Classes;
const OptionalClasses$1 = $TV($EXPECT($L3, fail, "OptionalClasses \"\""), function($loc, $0, $1) {return []});
function OptionalClasses(state) {
  return OptionalClasses$0(state) || OptionalClasses$1(state)
}

const Classes$0 = $P(Class);
function Classes(state) {
  return Classes$0(state);
}

const Class$0 = $TS($S($EXPECT($L4, fail, "Class \".\""), Identifier), function($loc, $0, $1, $2) {return ["class", $2]});
const Class$1 = $TS($S($EXPECT($L4, fail, "Class \".\""), $N(Identifier)), function($loc, $0, $1, $2) {throw "Expected a class name"});
const Class$2 = IdError;
function Class(state) {
  return Class$0(state) || Class$1(state) || Class$2(state)
}

const OptionalIds$0 = $TV($E(Ids), function($loc, $0, $1) {return $1 || []});
function OptionalIds(state) {
  return OptionalIds$0(state);
}

const Ids$0 = $TS($S(Id), function($loc, $0, $1) {return [ $1 ]});
function Ids(state) {
  return Ids$0(state);
}

const Id$0 = $TS($S($EXPECT($L5, fail, "Id \"#\""), Identifier), function($loc, $0, $1, $2) {return ["id", $2]});
const Id$1 = $TS($S($EXPECT($L5, fail, "Id \"#\""), $N(Identifier)), function($loc, $0, $1, $2) {throw "Expected an id name"});
function Id(state) {
  return Id$0(state) || Id$1(state)
}

const IdError$0 = $TV($EXPECT($L5, fail, "IdError \"#\""), function($loc, $0, $1) {throw "Ids must appear before classes and attributes. Elements can only have one id."});
function IdError(state) {
  return IdError$0(state);
}

const ClassError$0 = $TV($EXPECT($L4, fail, "ClassError \".\""), function($loc, $0, $1) {throw "Classes cannot appear after attributes."});
function ClassError(state) {
  return ClassError$0(state);
}

const TagName$0 = Identifier;
function TagName(state) {
  return TagName$0(state);
}

const OptionalAttributes$0 = $TS($S($EXPECT($L6, fail, "OptionalAttributes \"(\""), $E(__), $P(Attribute), $EXPECT($L7, fail, "OptionalAttributes \")\""), $E(IdError), $E(ClassError)), function($loc, $0, $1, $2, $3, $4, $5, $6) {return $3});
const OptionalAttributes$1 = $TV($EXPECT($L6, fail, "OptionalAttributes \"(\""), function($loc, $0, $1) {throw "Invalid attributes"});
const OptionalAttributes$2 = $TV($EXPECT($L3, fail, "OptionalAttributes \"\""), function($loc, $0, $1) {return []});
function OptionalAttributes(state) {
  return OptionalAttributes$0(state) || OptionalAttributes$1(state) || OptionalAttributes$2(state)
}

const Attribute$0 = $TS($S(AtIdentifier, $E(__)), function($loc, $0, $1, $2) {return [$1.bind, $1]});
const Attribute$1 = $T($S(EqBinding, $E(__)), function(value) { return value[0] });
const Attribute$2 = $TS($S(Identifier, $E(__)), function($loc, $0, $1, $2) {return [$1, ""]});
function Attribute(state) {
  return Attribute$0(state) || Attribute$1(state) || Attribute$2(state)
}

const AtIdentifier$0 = $TS($S($EXPECT($L8, fail, "AtIdentifier \"@\""), Identifier), function($loc, $0, $1, $2) {return {
  bind: $2
}});
function AtIdentifier(state) {
  return AtIdentifier$0(state);
}

const EqBinding$0 = $T($S(Identifier, $EXPECT($L2, fail, "EqBinding \"=\""), $C(AtIdentifier, Value)), function(value) { return [value[0], value[2]] });
function EqBinding(state) {
  return EqBinding$0(state);
}

const Identifier$0 = $R$0($EXPECT($R1, fail, "Identifier /[a-zA-Z][a-zA-Z0-9-]*/"));
function Identifier(state) {
  return Identifier$0(state);
}

const Indent$0 = $TV($Q($C($EXPECT($L9, fail, "Indent \"  \""), $EXPECT($L10, fail, "Indent \"\\\\t\""))), function($loc, $0, $1) {return $1.length});
function Indent(state) {
  return Indent$0(state);
}

const _$0 = $R$0($EXPECT($R2, fail, "_ /[ \\t]+/"));
function _(state) {
  return _$0(state);
}

const __$0 = $P($C($R$0($EXPECT($R3, fail, "__ /[ \\t]/")), EOL));
function __(state) {
  return __$0(state);
}

const Value$0 = $TS($S($EXPECT($L11, fail, "Value \"\\\\\\\"\""), $Q(DoubleStringCharacter), $EXPECT($L11, fail, "Value \"\\\\\\\"\"")), function($loc, $0, $1, $2, $3) {return $2.join("")});
const Value$1 = $TS($S($EXPECT($L12, fail, "Value \"'\""), $Q(SingleStringCharacter), $EXPECT($L12, fail, "Value \"'\"")), function($loc, $0, $1, $2, $3) {return $2.join("")});
const Value$2 = Number;
function Value(state) {
  return Value$0(state) || Value$1(state) || Value$2(state)
}

const DoubleStringCharacter$0 = $T($S($N($C($EXPECT($L11, fail, "DoubleStringCharacter \"\\\\\\\"\""), $EXPECT($L13, fail, "DoubleStringCharacter \"\\\\\\\\\""))), $EXPECT($R4, fail, "DoubleStringCharacter /./")), function(value) { return value[1] });
const DoubleStringCharacter$1 = $T($S($EXPECT($L13, fail, "DoubleStringCharacter \"\\\\\\\\\""), EscapeSequence), function(value) { return value[1] });
function DoubleStringCharacter(state) {
  return DoubleStringCharacter$0(state) || DoubleStringCharacter$1(state)
}

const SingleStringCharacter$0 = $T($S($N($C($EXPECT($L12, fail, "SingleStringCharacter \"'\""), $EXPECT($L13, fail, "SingleStringCharacter \"\\\\\\\\\""))), $EXPECT($R4, fail, "SingleStringCharacter /./")), function(value) { return value[1] });
const SingleStringCharacter$1 = $T($S($EXPECT($L13, fail, "SingleStringCharacter \"\\\\\\\\\""), EscapeSequence), function(value) { return value[1] });
function SingleStringCharacter(state) {
  return SingleStringCharacter$0(state) || SingleStringCharacter$1(state)
}

const EscapeSequence$0 = $EXPECT($L12, fail, "EscapeSequence \"'\"");
const EscapeSequence$1 = $EXPECT($L11, fail, "EscapeSequence \"\\\\\\\"\"");
const EscapeSequence$2 = $EXPECT($L13, fail, "EscapeSequence \"\\\\\\\\\"");
const EscapeSequence$3 = $TR($EXPECT($R4, fail, "EscapeSequence /./"), function($loc, $0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {return "\\" + $0});
function EscapeSequence(state) {
  return EscapeSequence$0(state) || EscapeSequence$1(state) || EscapeSequence$2(state) || EscapeSequence$3(state)
}

const Number$0 = $R$0($EXPECT($R5, fail, "Number /-?[0-9]+\\.[0-9]+/"));
const Number$1 = $R$0($EXPECT($R6, fail, "Number /-?[0-9]+/"));
function Number(state) {
  return Number$0(state) || Number$1(state)
}

const EOS$0 = $S($P($S($E(_), EOL)), _, EOF);
const EOS$1 = $P($S($E(_), EOL));
const EOS$2 = EOF;
function EOS(state) {
  return EOS$0(state) || EOS$1(state) || EOS$2(state)
}

const EOL$0 = $EXPECT($L14, fail, "EOL \"\\\\r\\\\n\"");
const EOL$1 = $EXPECT($L15, fail, "EOL \"\\\\n\"");
const EOL$2 = $EXPECT($L16, fail, "EOL \"\\\\r\"");
function EOL(state) {
  return EOL$0(state) || EOL$1(state) || EOL$2(state)
}

const EOF$0 = $N($R$0($EXPECT($R7, fail, "EOF /[\\s\\S]/")));
function EOF(state) {
  return EOF$0(state);
}

module.exports = {
  parse: parse
}